import { Box, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { FileIcon } from 'assets/icons/v2';
import { TextCellProps } from '../types/Cell';

export interface TextCellWithIconProps extends TextCellProps {
  icon?: ReactElement;
  iconBg?: string;
}

export const TextCellWithIcon = ({
  label,
  textStyle = 'body.m.medium',
  lineClamp = 1,
  icon = <FileIcon boxSize="16px" />,
  iconBg = 'background.secondary',
  ...props
}: TextCellWithIconProps): React.ReactElement => {
  return (
    <Box
      maxWidth={{ base: '400px', md: '550px' }}
      position="relative"
      p="0 10px 0 0"
      display="flex"
      alignItems="center"
      gap="xs"
    >
      <Box
        bg={iconBg}
        borderRadius="[4px]"
        p="2xs"
        display="flex"
        alignItems="center"
        justifyContent="center"
        boxSize="[26px]"
        minWidth="[26px]"
        mr="[2px]"
      >
        {icon}
      </Box>
      <Text
        textStyle={textStyle}
        lineClamp={lineClamp}
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace={lineClamp === 1 ? 'nowrap' : 'normal'}
        {...props}
      >
        {label}
      </Text>
    </Box>
  );
};
